import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PATH_APP } from "../../routes/paths";

// Hooks & Utils
import useScreenSize from "../../hooks/useScreenSize";
import { instrumentToGender } from "../../utils";

// Assets
import ArrowLeftIcon from "../../assets/icons/arrow-left.svg?react";
import SearchIcon from "../../assets/icons/search-icon.svg?react";

// Styles
import styles from "./MobileGenericHeader.module.scss";

const pathTitles: Record<string, string> = {
  [PATH_APP.valuation]: "Valuación de cartera",
  [PATH_APP.returns]: "Evolución de cartera",
  [PATH_APP.reports]: "Informes de cartera",
  [PATH_APP.transactions]: "Transferencias",
  [PATH_APP.activity]: "Actividad",
  [PATH_APP.profile]: "Perfil",
  [PATH_APP.research]: "Research",
  [PATH_APP.help]: "Ayuda",
  [PATH_APP.market]: "Operar",
  [PATH_APP.favorites]: "Favoritos",
  [PATH_APP.searchInstruments]: "Buscar instrumentos",
  [PATH_APP.searchFavorites]: "Buscar favoritos",
};

interface MobileGenericHeaderProps {
  propTitle?: string;
  className?: string;
}

const MobileGenericHeader = ({
  propTitle,
  className,
}: MobileGenericHeaderProps) => {
  const { isMobile } = useScreenSize();
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const { instrumentType } = useParams<{ instrumentType?: string }>();

  const handleGoBack = () => navigate(-1);

  const handleSearch = () => {
    if (pathname === PATH_APP.market) {
      navigate(PATH_APP.searchInstruments);
    } else if (pathname === PATH_APP.favorites) {
      navigate(PATH_APP.searchFavorites);
    }
  };

  const getHeaderTitle = () => {
    if (pathname.startsWith(PATH_APP.searchInstruments) && instrumentType) {
      const instrumentName = instrumentType || "instrumentos";
      return { title: `Buscar ${instrumentName}` };
    }

    if (pathname.startsWith(PATH_APP.searchFavorites) && instrumentType) {
      const instrumentName = instrumentType || "favoritos";
      const favoriteWord =
        instrumentToGender[instrumentName] === "f" ? "favoritas" : "favoritos";
      return { title: `Buscar ${instrumentName} ${favoriteWord}` };
    }

    const yearReportsMatch = pathname.match(/^\/cartera\/reportes\/(\d{4})$/);
    if (yearReportsMatch) {
      const year = yearReportsMatch[1];
      return { title: `Informes ${year}` };
    }

    return { title: pathTitles[pathname] || "" };
  };

  const { title: headerTitleFromPath } = getHeaderTitle();
  const headerTitle = propTitle || headerTitleFromPath;

  if (!isMobile || !headerTitle) return null;

  const {
    headerContainer,
    headerContent,
    leftGroup,
    backButton,
    title,
    rightButton,
  } = styles;

  const isMarket = pathname === PATH_APP.market;
  const isFavorites = pathname === PATH_APP.favorites;

  return (
    <div className={`${headerContainer} ${className || ""}`}>
      <div className={headerContent}>
        <div className={leftGroup}>
          {!isMarket && (
            <button className={backButton} onClick={handleGoBack} type="button">
              <ArrowLeftIcon />
            </button>
          )}
          <h1 className={title}>{headerTitle}</h1>
        </div>

        {(isMarket || isFavorites) && (
          <button
            className={rightButton}
            onClick={handleSearch}
            type="button"
            aria-label="Buscar"
          >
            <SearchIcon />
          </button>
        )}
      </div>
    </div>
  );
};

export default MobileGenericHeader;
